module.exports = __webpack_public_path__ + "img/ab_left1.81850ab5.png";